module.exports = "/_next/static/images/screen-2-c5371d951c7111e7de2aa2a695ddc8b0.jpg.webp";